const backup={
    data:{},
    getItem(key){
       if(arguments.length<1)throw new Error('1 argument required to get Item.'); 
       return this.data[key]??null; 
    },
    setItem(key,value){
       if(arguments.length<2)throw new Error('2 arguments required to set Item.');
       this.data[key]=value; 
    },
    removeItem(key){
        if(arguments.length<1)throw new Error('1 argument required to remove Item.');  
        delete this.data[key];
    },
    clear(){
        this.data={};
    }
}
const createStorage = ()=> {
    const storage=localStorage||window.localStorage||window.sessionStorage||backup;

    function set(key,value){    
        value=JSON.stringify(value);   
        storage.setItem(key,value);
    }

    function get(key){
        let value=storage.getItem(key);
        value=JSON.parse(value);
        return value;
    }

    function remove(key){
        storage.removeItem(key);
    }

    function clear(){
        storage.clear();
    }

    return {get,set,remove,clear};
}

const localStore=createStorage();

export default localStore;